import { AbstractBlock } from 'starting-blocks'
import Vue from 'vue'
export default class ActionButtonBlock extends AbstractBlock {
  constructor(container) {
    super(container, 'ActionButtonBlock')
    this.exampleElement = null
  }

  init() {
    super.init()
    const vm = new Vue({
      el: this.rootElement,
      name: this.rootElement.dataset.nodeType,
      data: {
        open: false,
        addressOpen: false,
      },
      methods: {},
      computed: {},
    })
    // console.log("ActionButtonBlock", this.rootElement);
  }

  initEvents() {
    super.initEvents()
    // register events like "click", "input"..
  }

  destroy() {
    super.destroy()
    // only needed when using page transitions
  }

  destroyEvents() {
    super.destroyEvents()
    // only needed when using page transitions
  }

  onResize() {
    super.onResize()
    // this is debounced by default
  }

  onPageReady() {
    super.onPageReady()
  }
}
